import { Outlet, useParams } from 'react-router-dom'
import invariant from 'tiny-invariant'

import { StandardLayout } from '@sequencehq/core-components'

import { CustomerContactsRoot } from 'CustomerContacts/index'
import { CustomerContextProvider } from './hooks/useCustomerContext'
import { CustomerOverviewInspector } from './CustomerOverviewInspector'
import { HeaderBreadcrumbs, HeaderButtons } from './components'

export const CustomerPageLayout = () => {
  const { customerId } = useParams<{ customerId: string }>()

  invariant(customerId, 'customerId is required')

  return (
    <CustomerContextProvider customerId={customerId}>
      <CustomerContactsRoot>
        <StandardLayout
          header={
            <StandardLayout.Header
              title={<HeaderBreadcrumbs />}
              actions={
                <StandardLayout.Actions>
                  <HeaderButtons />
                </StandardLayout.Actions>
              }
            />
          }
          content={
            <StandardLayout.Content scrollable>
              <Outlet />
            </StandardLayout.Content>
          }
          inspector={<CustomerOverviewInspector />}
        />
      </CustomerContactsRoot>
    </CustomerContextProvider>
  )
}
